function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { ADD_SNACK, REMOVE_SNACK, REMOVE_SNACK_BY_UNIQUE_ID } from '../actions/snackbarActions';
var initalState = {
  snacks: []
};
export default function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
  var _ref = arguments[1];
  var payload = _ref.payload,
    type = _ref.type;
  var snacks = state.snacks;
  switch (type) {
    case ADD_SNACK:
      return {
        snacks: [].concat(_toConsumableArray(snacks), [payload])
      };
    case REMOVE_SNACK_BY_UNIQUE_ID:
      return {
        snacks: snacks.filter(function (snack) {
          return snack.uniqueId !== payload;
        })
      };
    case REMOVE_SNACK:
      var alreadyRemoved = false;
      return {
        snacks: snacks.filter(function (snack) {
          if (alreadyRemoved || snack.id !== payload) return true;
          if (snack.id === payload) {
            alreadyRemoved = true;
          }
          return false;
        })
      };
    default:
      return state;
  }
}